module.exports = __webpack_public_path__ + "static/media/Header.4ffae417.png";